/**
 * variant-upsell-filter.js — kontextový filtr „Výhodné balení" dle příchuti, s pamětí.
 *
 * Server (variant-main-picker.liquid) vykreslí VŠECHNA balení v `.variant-upsell` s atributy
 * `data-pack-flavor` / `data-pack-assorted`. Tento skript zobrazí jen balení AKTUÁLNÍ příchuti
 * + assorted (Mix vždy). Když je vybrán assorted Mix (bez příchuti), použije POSLEDNÍ příchuť
 * (uloženou v paměti per produkt), takže flavor-specific Trojbalení po výběru Mixu NEZMIZÍ.
 *
 * Vanilla (bez importmapy). Re-aplikuje se po Horizon morphu (event `variant:update`).
 */
(() => {
  /** @type {Map<string,string>} productId -> poslední příchuť (lowercase) */
  const lastFlavor = new Map();

  function apply(card) {
    const pid = card.dataset.productId || '';
    const assortedSelected = card.dataset.selectedAssorted === 'true';
    const serverFlavor = (card.dataset.currentFlavor || '').trim().toLowerCase();

    let flavor;
    if (!assortedSelected) {
      flavor = serverFlavor;
      if (flavor) lastFlavor.set(pid, flavor);
    } else {
      flavor = lastFlavor.get(pid) || serverFlavor;
    }

    card.querySelectorAll('[data-pack-flavor]').forEach((el) => {
      const pf = (el.dataset.packFlavor || '').trim().toLowerCase();
      const assorted = el.dataset.packAssorted === 'true';
      // assorted (Mix) vždy; flavor-specific jen pro aktuální příchuť; bez příchuti ukaž vše
      el.hidden = !assorted && !!flavor && pf !== flavor;
    });

    // Zvýrazni aktuální příchuť i když je vybrané flavor-specific balení (pack). ALE u vybraného
    // Mixu (assorted = všechny příchutě) se konkrétní příchuť ODZNAČÍ → žádný chip není `--current`.
    // `flavor` (zapamatovaná) se dál používá jen k filtrování flavor-specific balení, ne ke zvýraznění.
    const picker = card.closest('variant-picker');
    if (picker) {
      const highlight = assortedSelected ? null : flavor;
      picker.querySelectorAll('.variant-option--buttons > label').forEach((lbl) => {
        const txt = (lbl.querySelector('.variant-option__button-label__text')?.textContent || '')
          .trim()
          .toLowerCase();
        lbl.classList.toggle('variant-option__button-label--current', Boolean(highlight) && txt === highlight);
      });
    }
  }

  function applyAll(root) {
    (root || document).querySelectorAll('.variant-upsell[data-product-id]').forEach(apply);
  }

  // Po změně varianty Horizon morphne sekci → re-aplikuj
  document.addEventListener('variant:update', () => requestAnimationFrame(() => applyAll()));

  // Klik na „1 ks" kartu (krok Množství) = cesta zpět ke kusovce.
  // Karta NENÍ radio (žádné duplicitní radio pro tutéž variantu) — deleguje výběr na
  // existující radio příchuti v kroku 1 přes data-option-value-id. Native variant-picker.js
  // pak zařídí morph. Delegováno na document → přežije morph (DOM se nahrazuje).
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-qty-single]') : null;
    if (!target || target.disabled) return;

    const picker = target.closest('variant-picker');
    const id = target.dataset.singleOptionId;
    if (!picker || !id) return;

    const radio = picker.querySelector(`input[data-option-value-id="${CSS.escape(id)}"]`);
    if (radio && !radio.checked) radio.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyAll());
  } else {
    applyAll();
  }
})();
